import styled from "styled-components";
import React, { useState } from "react";
import Checkbox from "../../Common/Components/Checkbox";
import CheckBoxTextOnRight from "./CheckboxTextOnRight";
import { changeHandlerAction } from "../action";
import store, { RootState } from "store";
import { useSelector } from "react-redux";

interface IPreferenceBox {
  objectKey: string;
  heading: string;
  description: string;
  options?: any[];
  checked: boolean;
}

const PreferenceBox: React.FC<IPreferenceBox> = (props: IPreferenceBox) => {
  // Props
  const { objectKey, heading, description, options, checked } = props;

  let isUnSubAllChecked = useSelector((state: RootState) => state.preferenceManagement.unsub_all);
  // Component Logic
  const handleOnChange = (key: string, value: boolean, id?: number) => {
    changeHandlerAction(key, value ? "1" : "0", id);
  };
  return (
    <>
      <Wrapper>
        {/* Preference Box */}
        <div className={`preferencebox ${!!options ? "upper-box-radius" : ""}`}>
          {/* Checkbox */}
          <div className="checkbox box">
            <Checkbox
              width={"18px"}
              height={"18px"}
              disabled={isUnSubAllChecked === "1" && objectKey !== "unsub_all"}
              onChange={(e: any) => handleOnChange(objectKey, e.target.checked)}
              checked={
                objectKey !== "news_letters" && objectKey !== "alerts"
                  ? checked
                  : store.getState().preferenceManagement[objectKey].every((item: any) => item.status === "1")
              }
            />
          </div>
          {/* Content */}
          <div>
            <h3 className="heading">{heading}</h3>
            <p className="description">{description}</p>
          </div>
        </div>
        {/* Options */}
        {options ? (
          <div className={`options ${!!options ? "lower-box-radius" : ""}`}>
            {options?.map((option) => (
              <CheckBoxTextOnRight
                id={option.id ?? option.name}
                objectKey={objectKey}
                description={option.name}
                checked={option.status === "1"}
                isOptions
              />
            ))}
          </div>
        ) : null}
      </Wrapper>
    </>
  );
};

export default PreferenceBox;

const Wrapper = styled.div`
  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  .preferencebox {
    display: flex;
    padding-left: 32px;
    background-color: white;
    width: 870px;
    border-radius: 10px;
    padding-top: 16px;
    @media all and (max-width: 767px) {
      width: 100%;
      padding-left: 23px;
      padding-right: 28px;
      padding-bottom: 22px;
    }
  }
  .upper-box-radius {
    border-radius: 10px 10px 0 0;
  }
  .lower-box-radius {
    border-radius: 0 0 10px 10px;
  }
  .box {
    padding-right: 10px;
    @media all and (max-width: 767px) {
      padding-right: 8px;
    }
  }
  .heading {
    font-family: "Roboto Slab";
    font-weight: 700;
    font-size: 30px;
    line-height: 20px;
    letter-spacing: -0.9px;
    color: #424b50;
    @media all and (max-width: 767px) {
      font-size: 24px;
      margin-bottom: 18px;
    }
  }
  .description {
    font-family: "Roboto";
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: -0.555556px;
    color: #5e7079;
    @media all and (max-width: 767px) {
      font-size: 16px;
      margin-bottom: 0;
    }
  }
  .options {
    background-color: #fafafa;
    border-bottom-right-radius: 10px;
    width: 870px;
    margin: 0 auto;
    padding-top: 22px;
    padding-left: 32px;
    margin-bottom: 5px;
    display: flex;
    flex-wrap: wrap;
    @media all and (max-width: 767px) {
      width: 100%;
      padding-left: 23px;
      padding-right: 28px;
      padding-bottom: 22px;
      flex-direction: column;
    }
  }
`;
